module.exports = __webpack_public_path__ + "svg/zoomout.8235adcde8adf6c201918bfd126ed152.svg";